// Uses requestAnimationFrame rather than setTimeout for smoother animation
// timing. Note that rAF is throttled or paused in background tabs, so progress
// will stall when the tab is hidden and resume when it regains focus.
export const createTimeout = () => {
    let handle;
    const cancel = () => {
        if (handle !== undefined) {
            window.cancelAnimationFrame(handle);
        }
    };
    const schedule = (callback, delay) => {
        cancel();
        let deltaTime;
        let start;
        const frame = (time) => {
            start = start || time;
            deltaTime = time - start;
            if (deltaTime > delay) {
                callback();
                return;
            }
            handle = window.requestAnimationFrame(frame);
        };
        handle = window.requestAnimationFrame(frame);
    };
    return {
        cancel,
        schedule,
    };
};
